var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dj-square",style:({
                'width':_vm.size,
                'paddingBottom':_vm.ratio,
                'borderRadius':_vm.borderRadius
              })},[_c('div',{staticClass:"dj-square__container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }